import { httpUtils } from './http.utilis';
import { IApiClientOptions } from '../models/api-client-request.model';
import { IRequestOptions } from '../models/request-options.model';
import { defaultPaginationParameters } from '../../pagination/data/pagination-parameters.data';

export class ApiClientOptionsUtils {
    static getCollectionUrl(defaultCollectionName: string, options?: IApiClientOptions): string {
        let collectionName = options?.collectionName ?? defaultCollectionName;

        if (options?.collectionSegment) {
            return `${collectionName}/${options.collectionSegment}`;
        }

        return collectionName;
    }

    static getResourceUrl<TId>(id: TId, options?: IApiClientOptions) {
        if (options?.resourceSegment) {
            return `${id}/${options.resourceSegment}`;
        }
        return id;
    }

    static getRequestOptions(options?: IApiClientOptions): IRequestOptions {
        let requestOptions: IRequestOptions = options?.requestOptions ?? {};
        let paginetionParameters = options?.paginationParameters || {};
        requestOptions.params = httpUtils.createHttpParams(paginetionParameters);
        return requestOptions;
    }
}
